'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const Spacer = ({ className, width = 0, height = 0 }) => {
  return React__default.default.createElement("div", { style: { width, height }, className, "data-zds": true });
};

exports.Spacer = Spacer;
//# sourceMappingURL=Spacer.cjs.js.map
